import styled from 'styled-components';
import palette from '@telus-uds/palette-allium/build/web/palette';

export const Button = styled.button`
  cursor: pointer;
  background: none;
  border: none;
  text-decoration: underline;
  white-space: nowrap;
`;

export const ButtonWrapper = styled.div`
  margin: 24px 0;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  white-space: nowrap;
`;

export const ExportButton = styled.button`
  color: ${palette.color.white};
  background-color: ${palette.color.greenAccessible};
`;

export const SearchWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  padding: 16px 0;
  @media screen and (max-width: 992px) {
    justify-content: flex-start;
  }
`;
